import classNames from "classnames";
import { FilterContext } from "components/filters/FilterContext";
import moment from "moment";
import React, { useContext } from "react";
import { useViewport } from "utilities/hookutils";
import { flattenPeriodList, getMonthsList } from "../periodfilter/timeutils";
import { getPageNumbers } from "utilities/paginationUtils";

export const MonthNavigationFilter = () => {
  const filterContext = useContext(FilterContext);
  const monthFilter = filterContext.getValue("month");
  const month = monthFilter.month;
  const viewport = useViewport();

  let pagesBeforeAndAfterCenterPoint = 3;
  switch (viewport) {
    case "mobile":
      pagesBeforeAndAfterCenterPoint = 1;
      break;
    case "desktopSmall":
      pagesBeforeAndAfterCenterPoint = 3;
      break;
    default:
      pagesBeforeAndAfterCenterPoint = 5;
      break;
  }

  const onGoToMonth = (month: moment.Moment) => {
    filterContext.setValue("month", { month });
  }

  if (month == null) {
    return null;
  }

  const list = [0, ...flattenPeriodList(getMonthsList())];
  const currentTime = month.valueOf();
  const currentIndex = list.findIndex(x => x >= currentTime);
  const entries = getPageNumbers(currentIndex, list.length - 1, pagesBeforeAndAfterCenterPoint);
  const index = entries.findIndex(x => x === currentIndex);
  const months = entries.map(x => moment.utc(list[x]));

  return <div className="pagination_small">
    <div className="pages">
      {months.map((m, idx) => {
        const numberClasses = classNames({
          current: idx === index,
        });

        return <div
          key={`${m.year()}-${m.month()}`}
          onClick={() => { onGoToMonth(m) }}
          className={numberClasses}>
          {m.format("MMM YY")}
        </div>;
      })}
    </div>
  </div>
};